<template>
    <div class="physical-storage-process">
        <m-pane
                ref="tablePage"
                class="tablePage"
                pageID="processInfo"
                :config="config"
                :totalData="totalData"
                :pageTotal="pageTotal"
                :loading="loading"
                :currentPage="currentPage"
                @attachment-btn="handleAttachment"
                @del-btn="handleDelete"
                @selectChange="selectChange"
                @pageChange="pageChange"
                @sizeChange="sizeChange">
        </m-pane>
    </div>
</template>

<script>
import { getProcessList } from '../../../../../api/addPhysicalStorage.js';
import { dictWithUrl } from '@/components/lots/api';
import config from './processConfig.js';
import mPane from '../../../../../components/Table/Index.vue';
import { FOUR } from '../../../../../constant/constant.js';
import { deleteMipAudit } from '../../../../../api/register/processInfo.js';
const CAO_GAO = '00';
export default {
    name: 'physicalStorage-process',
    components: { mPane },
    props: {
        whCode: {
            type: String,
            default() {
                return '';
            }
        },
        activeName: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            dict: {},
            selected: [],
            searchDataLists: {},
            dataObj: {},
            currentPage: 1,
            pageNo: 1,
            pageSize: 10,
            selectData: [],
            pageTotal: 0,
            totalData: [],
            loading: false,
            config
        };
    },
    methods: {
        handleGetProcessList() {
            const params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                whCode: this.whCode
            };
            getProcessList(params).then(res => {
                if (res && +res.code === 0) {
                    this.pageTotal = res.data.totalCount;
                    this.totalData = this.formatData(res.data.list);
                    this.loading = false;
                }
            }).catch(e => { this.loading = false; });
        },
        selectChange(row) {
            this.selected = row;
        },
        handleAttachment(row) {
            const { auditMipId, auditMipUrl, auditStatus } = row;
            const path = `/addPhysicalStorage?whCode=${this.whCode}`;
            this.$router.push({
                name: 'mipIframe',
                query: { fdStatus: auditStatus, url: auditMipUrl, processId: auditMipId, path }
            });
        },
        pageChange(data) {
            this.pageNo = data;
            this.handleGetProcessList();
        },
        sizeChange(data) {
            this.pageSize = data;
            this.handleGetProcessList();
        },
        formatData(data) {
            return data.map(item => {
                item.auditType_ = this.dict['SYS_SU_MIP_AUDIT_TYPE'][item.auditType];
                item.auditStatus_ = this.dict['SRM_AUDIT_STATUS'][item.auditStatus];
                return item;
            });
        },
        handleDelete(row) {
            if (row.auditStatus === CAO_GAO) {
                this.$confirm('是否确定删除该流程信息?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const params = {
                        id: row.id,
                        auditType: row.auditType,
                        auditId: row.auditMipId
                    };
                    deleteMipAudit(params).then(res => {
                        if (res && res.code === '0') {
                            this.$message.success('删除成功！');
                            this.handleGetProcessList();
                            this.$emit('on-delete-process')
                        }
                    });
                });
            } else {
                return this.$message.warning('非草稿状态不允许删除！');
            }
        }
    },
    mounted() {
        dictWithUrl('SYS_SU_MIP_AUDIT_TYPE,SRM_AUDIT_STATUS').then(res => {
            this.dict = res.data;
            this.handleGetProcessList();
        });
    },
    watch: {
        activeName(nVal) {
            if (nVal === FOUR) {
                this.handleGetProcessList();
            }
        }
    }
};
</script>

<style lang="less"></style>